import { axiosIdentity } from './axiosInstances'
import { AxiosResponse } from 'axios'
import { ICountry } from '../../models/ICountry'

export const getCountries = () => {
  return axiosIdentity
    .get(`/countries`)
    .then((res: AxiosResponse<ICountry[]>) => res.data)
}
